import { MenuItem, Select } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function SelectBox(props) {
  const { label, data, onChange, value, nullable = true, multiple } = props;
  return (
    <Grid container alignItems="center">
      <Grid item xs="auto" mr={1}>
        <Typography>{label}</Typography>
      </Grid>
      <Grid item xs="auto">
        <Select
          value={value || -1}
          onChange={onChange}
          sx={{ minWidth: 70 }}
          multiple={multiple}
          {...props}
        >
          {nullable && (
            <MenuItem key="unselected" value="-1">
              [未選択]
            </MenuItem>
          )}
          {data.map((item, i) => {
            return (
              <MenuItem key={`${label}_${item.key}`} value={item.key}>
                {item.value}
              </MenuItem>
            );
          })}
        </Select>
      </Grid>
    </Grid>
  );
}
